import { useState } from "react";
import { toast } from "sonner";
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { RootState } from '@/store';
import { Sports ,Court,DataToUpdateSlots,DataToUpdateForSlotsByGroupIdType,groupIdType} from '@/types/interfaceType';

import OffersManagement from "@/components/offerManagement/OffersManagement";


const OfferManagementPage = () => {
    const dispatch = useAppDispatch()

  return (
    <div className="space-y-6">
      <OffersManagement

      />
    
    </div>
  );
};

export default OfferManagementPage;
